/**
 * IHE XDS.b / XCA Configuration Admin Page
 */

import React from 'react';
import { IHEConfigManager } from '@/components/admin/IHEConfigManager';
import { PageHeader, PageContainer } from '@/components/weavein';

export default function IHEConfigPage() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader
        eyebrow="Admin · Integrations"
        title="IHE Document Exchange"
        description="Configure IHE XDS.b registry/repository and XCA cross-community gateway for document sharing with LANES LA."
      />
      <PageContainer>
        <IHEConfigManager />
      </PageContainer>
    </div>
  );
}
